import type { SortOptionsDirection } from 'dashboard/types';

export type SortOptions<T extends string = string> = {
  sortBy: T;
  sortDir: SortOptionsDirection;
};

export interface SortOptionsWithDefaults<T extends string = string>
  extends SortOptions<T> {
  defaultSortDir?: SortOptionsDirection;
}

/**
 * Cycle through sorting states for a table column.
 * Given the requested `field` to sort by, along with the current sorting
 * state of the table (`SortOptionsWithDefaults`), return a new sorting
 * state, with "sortBy" and "sortDir" values (`SortOptions`).
 */
export default function cycleSortOptions<T extends string>(
  field: T,
  { sortBy, sortDir, defaultSortDir = 'asc' }: SortOptionsWithDefaults<T>,
): SortOptions<T> {
  const newSortOptions: SortOptions<T> = { sortBy, sortDir };

  // always set new sortBy field
  newSortOptions.sortBy = field;

  if (sortBy === field) {
    // cycle between SortOptionsDirection
    newSortOptions.sortDir = sortDir === 'asc' ? 'desc' : 'asc';
  } else {
    // if changing columns/fields, set direction to default SortOptionsDirection
    newSortOptions.sortDir = defaultSortDir;
  }

  return newSortOptions;
}
